import { render, staticRenderFns } from "./IncidentFormModal.vue?vue&type=template&id=3834bfe0&scoped=true&"
import script from "./IncidentFormModal.vue?vue&type=script&lang=js&"
export * from "./IncidentFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3834bfe0",
  null
  
)

export default component.exports